// Fetch list

export const FETCH = 'reportCostCenterProfits.FETCH'
export const FETCH_STARTED = 'reportCostCenterProfits.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCostCenterProfits.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCostCenterProfits.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCostCenterProfits.FETCH_CANCELLED'

// Export

export const EXPORT = 'reportCostCenterProfits.EXPORT'
export const EXPORT_FULFILLED = 'reportCostCenterProfits.EXPORT_FULFILLED'

// Clear

export const CLEAR = 'reportCostCenterProfits.CLEAR'

// Fetch details

export const FETCH_DETAILS = 'reportCostCenterProfits.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportCostCenterProfits.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportCostCenterProfits.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportCostCenterProfits.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportCostCenterProfits.FETCH_DETAILS_CANCELLED'

// Export details

export const EXPORT_DETAILS = 'reportCostCenterProfits.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportCostCenterProfits.EXPORT_DETAILS_FULFILLED'

// Clear details

export const CLEAR_DETAILS = 'reportCostCenterProfits.CLEAR_DETAILS'
